<template>
  <div class="content">

    <!-- Nagłówek z przyciskiem rozwijania filtrów, widoczny tylko dla kroków 1 i 2 -->
    <!-- <h2
      data-bs-toggle="collapse"
      :href="`#current-filters`"
      role="button"
      aria-expanded="true"
      :aria-controls="`current-filters`"
      class="margin-0"
      v-if="current.step < 3"
    >
    {{ t('filters').toUpperCase() }}
    </h2> -->
    <!-- Dolny pasek z przyciskami nawigacyjnymi -->
    <div class="d-flex justify-content-between actions-down">
      <label class="location-view-toggle" for="location-view-toggle" v-if="current.step === 1 && !isSG">
        <span class="toggle-label">{{ t('map').toUpperCase() }}</span>
        <input id="location-view-toggle" type="checkbox" v-model="useMapLocationList" />
        <span class="toggle-slider"></span>
      </label>
      <!-- Przycisk powrotu (widoczny jeśli nie jesteśmy na 1 kroku) -->
      <button class="btn-prev" v-if="current.step > 1" @click="previousStep()">
        {{ t('back2').toUpperCase() }}
      </button>
      <!-- Przycisk "dalej"/"zastosuj" (widoczny jeśli nie jesteśmy na ostatnim kroku) -->
      <button class="btn-next ms-auto" v-if="current.step < 3" @click="nextStep()">
        {{ current.step < 2 ? t('next').toUpperCase() : t('apply').toUpperCase() }}
      </button>
    </div>

    <!-- Krok 1: Filtry preselekcji, wybór lokalizacji, kategorii pojazdu, pasa itd. -->
    <div v-if="current.step == 1" class="step1">
      <div class="location-pane">
        <component :is="locationListComponent" :store="filtersStore" />
      </div>
      <div class="filters-pane">
        <div class="d-flex step2" v-if="!shouldHideLocation">
          <vehicle-categories :store="filtersStore" />
          <lane-numbers :store="filtersStore" />
        </div>
    
        <div class="d-flex step3">
          <div class="d-flex">
            <violation-list :store="filtersStore" :step="current.step" v-if="!shouldHideLocation"/>
            <sort-by :store="filtersStore" />
          </div>
        </div>
      </div>
    </div>

    <!-- Krok 2: Podgląd danych pojazdu -->
    <div v-if="current.step == 2" class="step4">
      <div class="d-flex step4">
        <current-vehicle-data />
      </div>
    </div>

    <!-- Krok 3 i dalej: Wyniki, lista pojazdów, spinner ładowania, możliwość wrócenia -->
    <div v-if="current.step > 2">
      <!-- Filtry w formie collapse (można je zwinąć/rozwinąć) -->
      <div class="collapse" :id="`current-filters`">
        <div class="d-flex flex-column step1">
          <div class="d-flex">
            <div class="location-pane">
              <component :is="locationListComponent" :store="filtersStore" />
            </div>
            <div class="d-flex flex-column filters-pane">
              <div class="d-flex">
                <vehicle-categories :store="filtersStore" />
                <lane-numbers :store="filtersStore" />
              </div>
              <div class="d-flex justify-content-between">
                <violation-list :store="filtersStore" />
                <sort-by :store="filtersStore" />
              </div>
            </div>
          </div>
          <!-- Przycisk: Zastosuj filtry -->
          <div class="d-flex justify-content-between">
            <button
              class="btn-next ms-auto"
              @click="current.nextStep()"
              :aria-controls="`current-filters`"
              data-bs-toggle="collapse"
              :href="`#current-filters`"
            >
            {{ t('apply').toUpperCase() }}
            </button>
          </div>
        </div>
      </div>
      <div class="content">
        <!-- Przycisk powrotu do poprzedniego kroku -->
        <!-- <div class="d-flex justify-content-between actions">
          <button class="btn-prev" @click="current.previousStep()">
            {{ t('back2').toUpperCase() }}
          </button>
        </div> -->
        <!-- Spinner ładowania + informacja o zbyt długim czasie oczekiwania -->
        <spinner-element
          :loading="loading"
          :loading-to-long="loadingToLongSeconds > 30"
        />
        <!-- Lista pojazdów aktualnych -->
        <vehicle-list
            :data-service="vehService"
            :vehicle-list="current.vehicles"
            :timer-visible="false"
            details-path="vehicle"
            @openDetails="goToDetailsView"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { useCurrentFiltersStore } from "@/stores/currentFilters"; // Store filtrów
import CurrentMeasurementsService from "@/services/CurrentMeasurementsService"; // Serwis API
import VehicleList from "@/components/VehicleList";
import LocationList from "./filters/LocationList.vue";
import LocationList2 from "./filters/LocationList2.vue";
import LaneNumbers from "./filters/LaneNumbers.vue";
import VehicleCategories from "./filters/VehicleCategories.vue";
import ViolationList from "./filters/ViolationList.vue";
import SortBy from "./current/SortBy.vue";
import SpinnerElement from "./SpinnerElement.vue";
import CurrentVehicleData from "./current/CurrentVehicleData.vue";
import moment from "moment";
import { useCurrentStore } from "@/stores/current";
import { useRoute } from "vue-router";
import { computed } from "vue";
import { useUserStore } from "@/stores/user.store";
import { useAuthStore } from "@/stores/auth.store";
import { isSG } from "@/config/appVersion";

export default {
  name: "CurrentMeasurement",
  components: {
    LocationList,
    LocationList2,
    LaneNumbers,
    VehicleCategories,
    ViolationList,
    VehicleList,
    SortBy,
    SpinnerElement,
    CurrentVehicleData,
  },
  setup() {
    // Inicjalizacja Pinia stores oraz obiektów pomocniczych
    const current = useCurrentStore();
    const filtersStore = useCurrentFiltersStore();
    const route = useRoute();

    const shouldHideLocation = computed(() => {
      const version = process.env.VUE_APP_VERSION_NAME || "";
      return version.startsWith("SG");
    });

    const auth = useAuthStore();

    return { filtersStore, current, route, shouldHideLocation, auth, isSG };
  },
  data() {
    return {
      loading: false, // Czy trwa ładowanie pojazdów
      loadingToLongSeconds: 0, // Licznik do komunikatu o długim ładowaniu
      lastVehicleId: null, // Ostatni ID pojazdu (do różnicowania nowych danych)
      moment: moment,
      vehService: CurrentMeasurementsService, // Serwis danych pojazdów
      currentOrder: "desc", // Kierunek sortowania (nieużywane tutaj)
      currentLocationList: this.filtersStore.filters.locations, // Lista lokalizacji z filtrów
      momentDiffServer: 0, // Różnica czasu serwer-klient (synchronizacja czasowa)
      withClearOnSuccess: false, // Czy czyścić dane po sukcesie (nieużywane)
      lastId: null, // Ostatni znany ID pojazdu (pomocnicze przy pobieraniu)
      clockOffsetMs: 0,        // <-- wyrównanie zegara serwer - klient (ms)
      userStore: useUserStore(),
      useMapLocationList: false,
    };
  },
  computed: {
    locationListComponent() {
      return this.isSG ? "LocationList" : (this.useMapLocationList ? "LocationList2" : "LocationList");
    },
  },
  created() {
    // Nasłuchiwanie na zmiany kroku w store (przełączanie widoków)
    this.$watch(() => this.current.step, (newVal) => {
      this.setStep(newVal);
    }, { immediate: true });
  },
  methods: {
    goToDetailsView(vehicle) {
      const path = `/vehicle/${vehicle.id}/${vehicle.location.id}`;
      this.$router.push({ path });
    },
    // Obsługa zmiany kroku - ustawienie odpowiedniego widoku i zachowań
    async setStep(newVal) {
      if (newVal === 1) {
        // Krok 1 - czyszczenie, stopowanie timerów, reset danych
        this.current.stopIntervals();
        this.current.setVehicles([], this.momentDiffServer);
        this.loading = false;
        this.momentDiffServer = 0;
      } 
      if(newVal === 2) {
        // Krok 2 - tylko stopowanie timerów, brak ładowania
        this.current.stopIntervals();
        this.loading = false;
      }
      if (newVal === 3) {
        // Krok 3 - ładowanie danych, uruchomienie cyklicznego sprawdzania
        this.loading = true;

        await this.userStore.self?.();
        const addSec = this.userStore?.preferences?.checkpointAdditionalTime || 0;
        this.momentDiffServer = Number(addSec) * 1000; // na ms

        this.checkData();

        if (!this.current.getIntervalCheck()) {
          this.current.startIntervalCheck(setInterval(() => {
            this.checkData();
          }, 1000));
        }
      }
    },
    // Oblicz różnicę czasu systemowego między serwerem i klientem
    // getEqualizationTime(counters) {
    //   try {
    //     const serverSystemTime = new Date(counters.currentSystemTime);
    //     const clientSystemTime = new Date();
    //     this.momentDiffServer = serverSystemTime - clientSystemTime;
    //     return this.momentDiffServer;
    //   } catch (error) {
    //     console.error('Błąd podczas obliczania czasu równoważenia:', error);
    //     return 0;
    //   }
    // },
    getEqualizationTime(counters) {
      try {
        const serverSystemTime = new Date(counters.currentSystemTime).getTime();
        const clientSystemTime = Date.now();
        this.clockOffsetMs = serverSystemTime - clientSystemTime; // tylko offset zegara
        return this.clockOffsetMs;
      } catch (error) {
        console.error('Błąd podczas obliczania czasu równoważenia:', error);
        this.clockOffsetMs = 0;
        return 0;
      }
    },
    // Pobierz najnowsze dane, filtruj i aktualizuj store oraz stan ładowania
    // async checkData() {
    //   const now = Date.now() + this.momentDiffServer;

    //   // Odfiltruj pojazdy, które już przekroczyły checkpointTime (nieaktualne)
    //   const filteredVehicles = this.current.vehicles.filter(vehicle => {
    //     const checkpointTimestamp = new Date(vehicle.checkpointTime).getTime();
    //     return checkpointTimestamp > now;
    //   });

    //   // Jeśli lista pojazdów się zmieniła - zaktualizuj store
    //   if (filteredVehicles.length !== this.current.vehicles.length) {
    //     this.current.setVehicles(filteredVehicles, this.momentDiffServer);
    //     if (filteredVehicles.length === 0) {
    //       this.loading = true;
    //     }
    //   }

    //   // Sprawdź, czy wybrano jakąś lokalizację
    //   if (this.filtersStore.selectedLocation.length > 0) {
    //     const selectedIds = this.filtersStore.selectedLocation.map(loc => loc.id);
    //     if (!selectedIds.length) {
    //       return;
    //     }

    //     // Sprawdź czy lokalizacje wymagają odświeżenia
    //     let checkLocations = await CurrentMeasurementsService.checkLocations(selectedIds);
    //     if (checkLocations.refresh === true) {
    //       // Pobierz liczniki serwera do synchronizacji czasu
    //       const counters = await CurrentMeasurementsService.getCounters(selectedIds);
    //       this.getEqualizationTime(counters);

    //       // Pobierz nowe pojazdy
    //       let vehicleList = [];
    //       vehicleList = await CurrentMeasurementsService.getVehicleList(this.lastId);

    //       const newVehicles = [];
    //       const now = Date.now() + this.momentDiffServer;
    //       vehicleList.forEach(vehicle => {
    //         const checkpointTimestamp = new Date(vehicle.checkpointTime).getTime();
    //         if (checkpointTimestamp > now) {
    //           // Dodaj tylko nieistniejące pojazdy (unikaj duplikatów)
    //           const existingIds = new Set(this.current.vehicles.map(v => v.id));
    //           if (!existingIds.has(vehicle.id)) {
    //             this.current.vehicles.unshift(vehicle);
    //             newVehicles.push(vehicle);
    //           }
    //           // Zaktualizuj lastId jeśli trzeba
    //           if (vehicle.id > this.lastId) {
    //             this.lastId = vehicle.id;
    //           }
    //           this.loading = false;
    //         }
    //       });

    //       // Jeśli pojawiły się nowe pojazdy - zaktualizuj licznik, odśwież UI, uruchom beep itd.
    //       if (newVehicles.length > 0) {
    //         this.current.setVehicles(this.current.vehicles, this.momentDiffServer);
    //         CurrentMeasurementsService.beep();

    //         // Aktualizacja licznika nowych pojazdów tylko poza stroną główną
    //         if (this.route.path !== '/') {
    //           this.current.queryCount++;
    //           CurrentMeasurementsService.setNewCarsNumber(this.current.queryCount);
    //         } else {
    //           this.current.queryCount = 0;
    //           CurrentMeasurementsService.setNewCarsNumber(this.current.queryCount);
    //         }
    //       }
    //     }
    //   }
    // },
    async checkData() {
      // "Teraz" w czasie serwera (wyrównanym)
      const nowAligned = Date.now() + this.clockOffsetMs;

      // 1) odfiltruj obecną listę po checkpoint + dodatkowe okno
      const filteredVehicles = this.current.vehicles.filter(vehicle => {
        const cp = new Date(vehicle.checkpointTime).getTime();
        // this.auth.heartbeat("current-measurement");
        return (cp + this.momentDiffServer) > nowAligned;
      });

      if (filteredVehicles.length !== this.current.vehicles.length) {
        this.current.setVehicles(filteredVehicles, this.momentDiffServer);
        if (filteredVehicles.length === 0) {
          this.loading = true;
        }
      }

      // 2) sprawdź lokalizacje i ew. pobierz nowe
      if (this.filtersStore.selectedLocation.length > 0) {
        const selectedIds = this.filtersStore.selectedLocation.map(loc => loc.id);
        if (!selectedIds.length) return;

        let checkLocations = await CurrentMeasurementsService.checkLocations(selectedIds);
        if (checkLocations.refresh === true) {
          // pobierz zegar serwera -> ustaw clockOffsetMs
          const counters = await CurrentMeasurementsService.getCounters(selectedIds);
          this.getEqualizationTime(counters);

          // pobierz listę nowych pojazdów
          const vehicleList = await CurrentMeasurementsService.getVehicleList(this.lastId);

          const newVehicles = [];
          const existingIds = new Set(this.current.vehicles.map(v => v.id));

          vehicleList.forEach(vehicle => {
            const cp = new Date(vehicle.checkpointTime).getTime();
            // dopuszczamy rekord tylko jeśli checkpoint+okno > now (serwerowo wyrównane)
            if ((cp + this.momentDiffServer) > (Date.now() + this.clockOffsetMs)) {
              if (!existingIds.has(vehicle.id)) {
                this.current.vehicles.unshift(vehicle);
                newVehicles.push(vehicle);
              }
              if (vehicle.id > this.lastId) this.lastId = vehicle.id;
              this.loading = false;
            }
          });

          if (newVehicles.length > 0) {
            this.current.setVehicles(this.current.vehicles, this.momentDiffServer);
            CurrentMeasurementsService.beep();
            this.auth.heartbeat("current-measurement");

            if (this.route.path !== '/') {
              this.current.queryCount++;
              CurrentMeasurementsService.setNewCarsNumber(this.current.queryCount);
            } else {
              this.current.queryCount = 0;
              CurrentMeasurementsService.setNewCarsNumber(this.current.queryCount);
            }
          }
        }
      }
    },
    // Aktualizuj lokalny krok (np. po zmianie w store)
    // getCurrentStep() {
    //   this.step = this.current.step;
    // },
    // Przejdź do kolejnego kroku (wywołuje logikę store)
    nextStep() { this.current.nextStep(); },
    previousStep() { this.current.previousStep(); },
  },
};
</script>

<style scoped>
.content,
.step-content {
  width: 100%;
  min-height: 478px;
  scrollbar-gutter: stable;
}

.d-flex {
  width: 100%;
}

.content h2 {
  position: relative;
  margin: 0;
  padding: 15px 20px;
  background-color: white;
  cursor: default;
}

.content h2::after {
  width: 22px;
  height: 18px;
  position: absolute;
  left: 100px;
  top: 20px;
  content: "";
  background: url("../assets/icons/filtry.png") no-repeat left top;
}

.step1 {
  display: flex;
  width: 100%;
}

.location-pane {
  flex: 0 0 445px;
  width: 445px;
  min-width: 445px;
}

.filters-pane {
  flex: 1 1 auto;
  min-width: 0;
}

.step2 {
  border-bottom: 1px solid #bfbfbf;
}

h3 {
  position: relative;
  padding: 10px 20px;
  background-color: white;
  border-top: 1px solid #b8b8b6;
  margin-bottom: 0;
}

button {
  border: 0;
  font-size: 19px;
  font-weight: bold;
  background: none;
}

.btn-next {
  margin-right: 50px;
  padding: 8px 40px 8px 8px;
  position: relative;
  color: #58585a;
  margin-bottom: 15px;
  border: 1px solid #58585a;
}

.btn-next:before {
  content: "";
  position: absolute;
  right: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/dalej.png") no-repeat left top;
}

.btn-next:hover {
  color: black;
  background-color: #b8b8b6;
}

.btn-next:hover:before {
  background: url("../assets/icons/dalej_over.png") no-repeat left top;
}

.actions {
  background-color: white;
  min-height: 43px;
}

.actions .btn-prev {
  margin-left: 30px;
  padding: 8px 8px 8px 45px;
  position: relative;
  color: #58585a;
}

.actions .btn-prev:before {
  content: "";
  position: absolute;
  left: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/powrot.png") no-repeat left top;
}

.actions .btn-prev:hover {
  color: black;
}

.actions .btn-prev:hover:before {
  background: url("../assets/icons/powrot_over.png") no-repeat left top;
}

.actions-down {
  background-color: white;
  max-height: 43px;
}

.actions-down button {
  border: 0;
  font-size: 19px;
  font-weight: bold;
  background: none;
}

.location-view-toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin-left: 20px;
}

.toggle-label {
  font-size: 12px;
  font-weight: 700;
  color: #58585a;
  letter-spacing: 0.04em;
}

.location-view-toggle input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 999px;
  background-color: #cfd4da;
  transition: background-color 0.2s ease;
}

.toggle-slider::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  transition: transform 0.2s ease;
}

.location-view-toggle input:checked + .toggle-slider {
  background-color: #35c759;
}

.location-view-toggle input:checked + .toggle-slider::before {
  transform: translateX(20px);
}

.actions-down .btn-next {
  padding: 8px 40px 8px 8px;
  position: relative;
  color: #58585a;
}

.actions-down .btn-next:before {
  content: "";
  position: absolute;
  right: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/dalej.png") no-repeat left top;
}

.actions-down .btn-next:hover {
  color: black;
  background: none;
}

.actions-down .btn-next:hover:before {
  background: url("../assets/icons/dalej_over.png") no-repeat left top;
}

.actions-down .btn-prev {
  margin-left: 20px;
  padding: 8px 8px 8px 40px;
  position: relative;
  color: #58585a;
}

.actions-down .btn-prev:before {
  content: "";
  position: absolute;
  left: 0;
  top: 11px;
  width: 30px;
  height: 20px;
  background: url("../assets/icons/powrot.png") no-repeat left top;
}

.actions-down .btn-prev:hover {
  color: black;
}

.actions-down .btn-prev:hover:before {
  background: url("../assets/icons/powrot_over.png") no-repeat left top;
}
</style>
